import { render, staticRenderFns } from "./SingleToothSelector.vue?vue&type=template&id=90a92800"
import script from "./SingleToothSelector.vue?vue&type=script&lang=js"
export * from "./SingleToothSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports